module.exports = __webpack_public_path__ + "static/fonts/eiconfont.a4c35816.ttf";